import React, { Component } from "react";
import {
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Card,
  CardContent,
  Box,
  CircularProgress,
} from "@mui/material";
import ReactSelect from "react-select";
import { Table, TableRow, TableBody, TableCell } from "@mui/material";
import { evaluateBService } from "../../../service/manage/evaluate/evaluate_b.service";
import "./evaluate.css";
import { MarksheetService } from "../../../service/manage/mark_sheet/marksheet.service";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import debounce from "lodash.debounce";
import IconButton from "@mui/material/IconButton";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import {
  sweetErrorAlert,
  sweetStatusAlert,
  sweetSuccessAlert,
} from "../../../components/common/SweetAlert";
import { Spinner } from "react-bootstrap";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import "../../../components/admin/css/common.css";
import Button from "react-bootstrap/Button";
import SimpleReactValidator from "simple-react-validator";

class ManageFormView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveLoading: false,
      selectedTitle: "",
      responses: {},
      overallComments: "",
      forms: [],
      filledData: [],
      isStudentsLoading: false,
      students: [],
      selectedStudentId: "",
      selectedStudent: null,
      studentSearchTerm: "",
      sortColumn: "user_code",
      sortDirection: "desc",
      formSetupDataLoading: false,
      addVisibility: false,
      editVisibility: false,
      isDropHidden: false
    };

    this.debouncedHandleStudentSearch = debounce(this.fetchallstudent, 1000);
    this.createValidationsInstance();
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    const {
      userType,
      flg_list_active,
      owner_restriction,
      privilege_add,
      privilege_edit,
    } = this.props.props;

    if (privilege_add == "1") {
      this.setState({
        addVisibility: true,
      });
    }
    if (privilege_edit == "1") {
      this.setState({
        editVisibility: true,
      });
    }

    this.setState(
      {
        userType: userType,
        formViewPrivilage: this.props.formViewPrivilage,
        flg_list_active,
        owner_restriction,
      },
      () => {
        if (owner_restriction === null) {
          this.fetchallstudent();
          if (flg_list_active === 1) {
            this.setState({ isDropHidden: true });
          }
        }

        this.getAllForms();
      }
    );
  }

  getAllForms = () => {
    this.setState({ isTitleDataLoading: true });
    const { mid } = this.props.props;
    evaluateBService.getAllFormView(mid).then((response) => {
      if (response.success) {
        this.setState({
          forms: response.data.form_views,
          isTitleDataLoading: false,
        });
      } else {
        this.setState({ isTitleDataLoading: false });
      }
    });
  };

  fetchallstudent = () => {
    const { mid, form_list_id, lg_user_table_id, lg_user_id } =
      this.props.props;

    const { limit, offset, sortColumn, sortDirection, studentSearchTerm } =
      this.state;

    this.setState({ isStudentsLoading: true });
    MarksheetService.getAllEnrolledStudents(
      mid,
      form_list_id,
      lg_user_id,
      lg_user_table_id,
      5000,
      0,
      sortColumn,
      sortDirection,
      studentSearchTerm
    ).then((result) => {
      if (result.success) {
        const updatedStudentsArray = result.data.users.map((student) => ({
          ...student,
          status: false,
        }));
        this.setState({ students: updatedStudentsArray });
        this.setState({ isStudentsLoading: false });
      }
      this.setState({ isStudentsLoading: false });
    });
  };

  clearResponse = (questionId) => {
    const { addVisibility, editVisibility } = this.state;

    // Only proceed if both addVisibility and editVisibility are true
    if (addVisibility || editVisibility) {
      if (this.state.filledData.length > 0) {
        // Clear the response in the filledData array
        this.setState((prevState) => ({
          filledData: prevState.filledData.map((item) =>
            item.items.some((i) => i.item_id === questionId)
              ? {
                  ...item,
                  items: item.items.map((i) =>
                    i.item_id === questionId ? { ...i, choices: [] } : i
                  ),
                }
              : item
          ),
        }));
      } else {
        // Fresh form: Clear the response in the responses state
        this.setState((prevState) => ({
          responses: {
            ...prevState.responses,
            [questionId]: "",
          },
        }));
      }
    } else {
    }
  };
  handleTitleChange = async (event) => {
    const selectedTitle = event.target.value;
    const { selectedStudent } = this.state;
    this.setState({ selectedTitle }, async () => {
      if (this.state.isDropHidden) {
        if (selectedStudent) {
          this.getAllfilledFormSetupForAdmin(selectedTitle);
        }
      } else {
        await this.getAllfilledFormSetupForStudent(selectedTitle);
      }
    });
  };

  async getAllfilledFormSetupForStudent(selectedTitle) {
    const { lg_user_id, lg_user_table_id, mid } = this.props.props;
    this.setState({ formSetupDataLoading: true });

    try {
      const response = await evaluateBService.getAllSavedFormView(
        mid,
        selectedTitle.form_id,
        lg_user_id,
        lg_user_table_id
      );

      if (response.success) {
        this.setState({
          filledData: response.data.filled_forms,
          formSetupDataLoading: false,
        });
      } else {
        this.setState({ formSetupDataLoading: false });
      }
    } catch (error) {
      this.setState({ formSetupDataLoading: false });
      console.error("Error fetching filled forms:", error);
    }
  }

  getAllfilledFormSetupForAdmin = (selectedTitle) => {
    const { mid } = this.props.props;

    const { selectedStudent } = this.state;

    this.setState({ formSetupDataLoading: true });

    evaluateBService
      .getAllSavedFormView(
        mid,
        selectedTitle.form_id,
        selectedStudent.encrypted_user_id,
        selectedStudent.encrypted_user_table_id
      )
      .then((response) => {
        if (response.success) {
          this.setState({
            filledData: response.data.filled_forms,
            formSetupDataLoading: false,
          });
        } else {
          this.setState({ formSetupDataLoading: false });
        }
      });
  };

  handleResponseChange = (questionId, choiceId, value) => {
    const { addVisibility, editVisibility } = this.state;

    // Only proceed if both addVisibility and editVisibility are true
    if (addVisibility || editVisibility) {
      if (this.state.filledData.length > 0) {
        this.setState((prevState) => ({
          filledData: prevState.filledData.map((item) =>
            item.items.some((i) => i.item_id === questionId)
              ? {
                  ...item,
                  items: item.items.map((i) =>
                    i.item_id === questionId
                      ? {
                          ...i,
                          choices: [{ choice_id: choiceId, choice: value }],
                        }
                      : i
                  ),
                }
              : item
          ),
        }));
      } else {
        this.setState((prevState) => ({
          responses: {
            ...prevState.responses,
            [questionId]: {
              choiceId,
              value,
            },
          },
        }));
      }
    } else {
    }
  };

  handleCommentsChange = (event) => {
    const newComment = event.target.value;

    if (this.state.filledData.length > 0) {
      this.setState((prevState) => ({
        filledData: prevState.filledData.map((item) => ({
          ...item,
          comment: newComment,
        })),
      }));
    } else {
      this.setState({ overallComments: newComment });
    }
  };

  handleSubmit = () => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      const {
        selectedTitle,
        responses,
        overallComments,
        filledData,
        isDropHidden,
        selectedStudent,
      } = this.state;
      const { lg_user_id, lg_user_table_id, mid } = this.props.props;

      this.setState({ saveLoading: true });

      if (filledData.length > 0) {
        const clearFormViewsPayload = filledData[0].items.map((item) => ({
          comment: "",
          node_id: mid,
          create_user_id:lg_user_id,
          create_user_table_id:lg_user_table_id,
          user_id: !isDropHidden
            ? lg_user_id
            : selectedStudent.encrypted_user_id,
          user_table_id: !isDropHidden
            ? lg_user_table_id
            : selectedStudent.encrypted_user_table_id,
          form_id: selectedTitle.form_id,
          status: 0,
          item_id: item.item_id,
          choice_id: null,
          selected_choice: false,
        }));

        if (clearFormViewsPayload.length > 0) {
          evaluateBService
            .clearFormViews(clearFormViewsPayload)
            .then((result) => {
              if (result.success) {
                const saveFormViewsPayload = filledData[0].items.map((item) => {
                  const choice =
                    item.choices.length > 0 ? item.choices[0] : null;
                  return {
                    comment: filledData[0].comment,
                    node_id: mid,
                    create_user_id:lg_user_id,
                    create_user_table_id:lg_user_table_id,
                    user_id: !isDropHidden
                      ? lg_user_id
                      : selectedStudent.encrypted_user_id,
                    user_table_id: !isDropHidden
                      ? lg_user_table_id
                      : selectedStudent.encrypted_user_table_id,
                    form_id: selectedTitle.form_id,
                    status: 1,
                    item_id: item.item_id,
                    choice_id: choice ? choice.choice_id : null,
                    selected_choice: choice ? true : false,
                  };
                });

                this.saveFormViews(saveFormViewsPayload);
              } else {
                this.handleSaveError("Failed to clear the form");
              }
            });
        }
      } else {
        const saveFormViewsPayload = selectedTitle.items.map((item) => {
          const response = responses[item.item_id];
          return {
            comment: overallComments,
            node_id: mid,
            create_user_id:lg_user_id,
            create_user_table_id:lg_user_table_id,
            user_id: !isDropHidden
              ? lg_user_id
              : selectedStudent.encrypted_user_id,
            user_table_id: !isDropHidden
              ? lg_user_table_id
              : selectedStudent.encrypted_user_table_id,
            form_id: selectedTitle.form_id,
            status: 1,
            item_id: item.item_id,
            choice_id: response ? response.choiceId : null,
            selected_choice: response ? true : false,
          };
        });

        this.saveFormViews(saveFormViewsPayload);
      }
    }
  };

  saveFormViews = (payload) => {
    if (payload.length > 0) {
      evaluateBService.saveFormViews(payload).then((result) => {
        if (result.success) {
          sweetSuccessAlert("Success", "Form Saved successfully", "success");

          const clearedResponses = {};
          this.state.selectedTitle.items.forEach((item) => {
            clearedResponses[item.item_id] = "";
          });

          this.setState(
            {
              // selectedTitle: null,
              // responses: clearedResponses,
              overallComments: "",
              saveLoading: false,
              filledData: [],
            },
            () => {
              if (this.state.isDropHidden) {
                if (this.state.selectedStudent) {
                  this.getAllfilledFormSetupForAdmin(this.state.selectedTitle);
                }
              } else {
                this.getAllfilledFormSetupForStudent(this.state.selectedTitle);
              }
            }
          );
        } else {
          this.handleSaveError("Failed to save Form");
        }
      });
    } else {
      this.handleSaveError("Failed to save Form");
    }
  };

  handleSaveError = (message) => {
    sweetErrorAlert("Error", message);
    this.setState({ saveLoading: false });
  };

  handleFinalizeSubmit = () => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      const { selectedTitle, responses, overallComments, filledData } =
        this.state;
      const { lg_user_id, lg_user_table_id, mid } = this.props.props;

      this.setState({ saveLoading: true });

      let finalizeFormsPayload = [];

      // If filledData exists, it means the form has been filled before; clear and then finalize
      if (filledData.length > 0) {
        finalizeFormsPayload = filledData[0].items.map((item) => {
          const choice = item.choices.length > 0 ? item.choices[0] : null;
          return {
            comment: filledData[0].comment,
            node_id: mid,
            create_user_id: lg_user_id,
            create_user_table_id: lg_user_table_id,
            user_id: lg_user_id,
            user_table_id: lg_user_table_id,
            form_id: selectedTitle.form_id,
            status: 2, // Status 2 for finalized forms
            item_id: item.item_id,
            choice_id: choice ? choice.choice_id : null,
            selected_choice: choice ? true : false,
          };
        });

        // Clear form views first before finalizing
        evaluateBService.clearFormViews(finalizeFormsPayload).then((result) => {
          if (result.success) {
            this.saveAndFinalizeForm(finalizeFormsPayload);
          } else {
            this.handleSaveError("Failed to clear Form before finalizing");
          }
        });
      } else {
        // If no filledData, it's a fresh form; directly finalize
        finalizeFormsPayload = selectedTitle.items.map((item) => {
          const response = responses[item.item_id];
          return {
            comment: overallComments,
            node_id: mid,
            create_user_id: lg_user_id,
            create_user_table_id: lg_user_table_id,
            user_id: lg_user_id,
            user_table_id: lg_user_table_id,
            form_id: selectedTitle.form_id,
            status: 2,
            item_id: item.item_id,
            choice_id: response ? response.choiceId : null,
            selected_choice: response ? true : false,
          };
        });

        this.saveAndFinalizeForm(finalizeFormsPayload);
      }
    }
  };

  // Function to save and finalize the form
  saveAndFinalizeForm = (payload) => {
    if (payload.length > 0) {
      evaluateBService.saveFormViews(payload).then((result) => {
        if (result.success) {
          sweetSuccessAlert(
            "Success",
            "Form Saved and finalized successfully",
            "success"
          );

          const clearedResponses = {};
          this.state.selectedTitle.items.forEach((item) => {
            clearedResponses[item.item_id] = "";
          });

          this.setState({
            selectedTitle: null,
            responses: clearedResponses,
            overallComments: "",
            saveLoading: false,
          });
        } else {
          this.handleSaveError("Failed to save and finalize Form");
        }
      });
    } else {
      this.handleSaveError("Failed to save and finalize Form");
    }
  };

  // Error handling function
  handleSaveError = (message) => {
    sweetErrorAlert("Error", message);
    this.setState({ saveLoading: false });
  };

  handleDelete = () => {
    const {
      selectedTitle,
      responses,
      overallComments,
      filledDat,
      isDropHidden,
      selectedStudent,
    } = this.state;
    const { lg_user_id, lg_user_table_id, mid } = this.props.props;

    this.setState({ saveLoading: true });

    const DeleteFormsSubmit = [];
    for (let i = 0; i < selectedTitle.items.length; i++) {
      const itemId = selectedTitle.items[i].item_id;
      const response = responses[itemId];

      const updatedForms = {
        comment: "",
        node_id: mid,
        create_user_id: isDropHidden
          ? lg_user_id
          : selectedStudent.encrypted_user_id,
        create_user_table_id: isDropHidden
          ? lg_user_table_id
          : selectedStudent.encrypted_user_table_id,
        user_id: !isDropHidden ? lg_user_id : selectedStudent.encrypted_user_id,
        user_table_id: !isDropHidden
          ? lg_user_table_id
          : selectedStudent.encrypted_user_table_id,
        form_id: selectedTitle.form_id,
        status: 0,
        item_id: 0,
        choice_id: null,
        selected_choice: false,
      };

      DeleteFormsSubmit.push(updatedForms);
    }

    if (DeleteFormsSubmit.length > 0) {
      evaluateBService.DeleteFormViews(DeleteFormsSubmit).then((result) => {
        if (result.success) {
          sweetSuccessAlert("Success", "Form Deleted successfully", "success");

          const clearedResponses = {};
          selectedTitle.items.forEach((item) => {
            clearedResponses[item.item_id] = "";
          });

          this.setState({
            selectedTitle: null,
            responses: clearedResponses,
            overallComments: "",
            saveLoading: false,
            selectedStudent: null,
          });
        } else {
          sweetErrorAlert("Error", "Failed to save Form");
        }
        this.setState({ loading: false });
      });
    }
  };
  handleStudentSearch = (event) => {
    const regex = /^[a-zA-Z0-9\-@\[\]\s.&]*$/;
    if (event === "" || regex.test(event)) {
      let num = event;
      this.setState(
        {
          studentSearchTerm: num,
          searchError: false,
        },
        () => {
          this.debouncedHandleStudentSearch();
        }
      );
    } else {
      this.setState({ studentSearchTerm: event, searchError: true });
    }
  };
  shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  render() {
    const {
      selectedTitle,
      responses,
      overallComments,
      forms,
      isTitleDataLoading,
      isStudentsLoading,
      students,
      selectedStudentId,
      selectedStudent,
      flg_list_active,
      isDropHidden,
      filledData,
      formSetupDataLoading,
      saveLoading,
      owner_restriction,
      addVisibility,
      editVisibility,
    } = this.state;

    const { privilege_add, privilege_edit } = this.props.props;

    const options = students.map((student, index) => ({
      value: student.user_id,
      label: student.data_concat,
      user_table_id: student.user_table_id,
      encrypted_user_id: student.encrypted_user_id,
      encrypted_user_table_id: student.encrypted_user_table_id,
      previewLabel: `User ${index + 1}`,
    }));

    const shuffledOptions =
      this.state.selectedTitle?.show_user === 1
        ? this.shuffleArray(options)
        : options;
    return (
      <Container sx={{ mt: 5, display: "flex", justifyContent: "flex-start" }}>
        <Card variant="outlined" sx={{ p: 3, border: "none", width: "100%" }}>
          <CardContent className="feed">
            <Typography variant="h5" gutterBottom>
              Check list Form
            </Typography>
            {isDropHidden && (
              <div>
                <FormControl
                  style={{ width: "400px" }}
                  variant="outlined"
                  margin="normal"
                >
                  <InputLabel>Select Title</InputLabel>
                  <Select
                    value={selectedTitle}
                    onChange={this.handleTitleChange}
                    label="Select Title"
                  >
                    {isTitleDataLoading ? (
                      <MenuItem value="">
                        <Box
                          display="flex"
                          justifyContent="center"
                          width="100%"
                        >
                          <CircularProgress size={24} />
                        </Box>
                      </MenuItem>
                    ) : (
                      forms.map((title, index) => (
                        <MenuItem key={index} value={title}>
                          {title.title}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </div>
            )}
            {isDropHidden && selectedTitle && (
              <div>
                <Form.Group>
                  <Form.Label>Search User By Id*</Form.Label>
                  <ReactSelect
                    options={shuffledOptions}
                    value={this.state.selectedStudent}
                    isLoading={this.state.isStudentsLoading}
                    onChange={(selectedOption) => {
                      const selectedValue = selectedOption?.value;
                      this.setState(
                        {
                          selectedStudentId: selectedValue,
                          selectedStudent: selectedOption,
                          isModified: true,
                        },
                        () => {
                          if (this.state.selectedTitle) {
                            this.getAllfilledFormSetupForAdmin(
                              this.state.selectedTitle
                            );
                          }
                        }
                      );
                    }}
                    onInputChange={(inputValue) => {
                      if (inputValue) {
                        this.handleStudentSearch(inputValue);
                      }
                    }}
                    onMenuClose={() => {
                      if (this.state.studentSearchTerm) {
                        this.setState({ studentSearchTerm: "" }, () => {
                          this.fetchallstudent();
                        });
                      }
                    }}
                    getOptionLabel={(option) => {
                      return this.state.selectedTitle?.show_user === 1
                        ? option.previewLabel
                        : option.label;
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "400px",
                      }),
                    }}
                  />
                </Form.Group>
              </div>
            )}

            {!isDropHidden && (
              <div>
                <FormControl
                  style={{ width: "400px" }}
                  variant="outlined"
                  margin="normal"
                >
                  <InputLabel>Select Title</InputLabel>
                  <Select
                    value={selectedTitle}
                    onChange={this.handleTitleChange}
                    label="Select Title"
                  >
                    {isTitleDataLoading ? (
                      <MenuItem value="">
                        <Box
                          display="flex"
                          justifyContent="center"
                          width="100%"
                        >
                          <CircularProgress size={24} />
                        </Box>
                      </MenuItem>
                    ) : (
                      forms.map((title, index) => (
                        <MenuItem key={index} value={title}>
                          {title.title}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </div>
            )}
            <br />
            <Typography variant="h6" gutterBottom>
              {selectedTitle ? selectedTitle.description : ""}
            </Typography>
            <br />
            {saveLoading && (
              <PageSpinner id="show" text="Loading, Please wait!" />
            )}

            {formSetupDataLoading ? (
              <div
                className="loading-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : !isDropHidden && owner_restriction === 1 ? (
              selectedTitle && (
                <>
                  <Table>
                    {selectedTitle.items?.map((q) => {
                      const matchingFilledItem =
                        filledData.length > 0
                          ? filledData[0].items.find(
                              (filledItem) => filledItem.item_id === q.item_id
                            )
                          : null;

                      const preselectedValue = matchingFilledItem
                        ? matchingFilledItem.choices.find((filledChoice) =>
                            q.choices.some(
                              (choice) =>
                                choice.choice_id === filledChoice.choice_id
                            )
                          )?.choice || ""
                        : responses[q.item_id]?.value || "";

                      return (
                        <TableRow key={q.item_id}>
                          <TableCell>
                            <Typography variant="subtitle1" gutterBottom>
                              {q.item_name}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <RadioGroup
                              row
                              value={preselectedValue}
                              onChange={(event) => {
                                const selectedChoice = q.choices.find(
                                  (option) =>
                                    option.choice === event.target.value
                                );
                                this.handleResponseChange(
                                  q.item_id,
                                  selectedChoice?.choice_id,
                                  event.target.value
                                );
                              }}
                              disabled={!isDropHidden}
                            >
                              {q.choices?.map((option, index) => (
                                <FormControlLabel
                                  key={index}
                                  value={option.choice}
                                  control={<Radio />}
                                  label={option.choice}
                                />
                              ))}
                            </RadioGroup>
                          </TableCell>

                          <TableCell>
                            {addVisibility && (
                              <div>
                                <IconButton
                                  onClick={() => this.clearResponse(q.item_id)}
                                  size="large"
                                >
                                  <RestartAltIcon />
                                </IconButton>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Table>

                  <TextField
                    label="Overall Comments"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={
                      filledData.length > 0
                        ? filledData[0]?.comment || ""
                        : overallComments
                    }
                    disabled={!addVisibility}
                    onChange={this.handleCommentsChange}
                  />
                  {this.validator.message(
                    "overallComments", // Field name to validate
                    filledData.length > 0
                      ? filledData[0]?.comment || overallComments
                      : overallComments,
                    "max:1000",
                    {
                      className: "text-danger",
                      messages: {
                        max: "You can only add up to 1000 characters.",
                      },
                    }
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      {selectedTitle && !isDropHidden && privilege_add && (
                        <Button
                          className="insert-btn"
                          variant="primary"
                          onClick={this.handleSubmit}
                          style={{ width: "150px", marginLeft: 0 }}
                        >
                          Save
                        </Button>
                      )}
                    </div>

                    {selectedTitle && !isDropHidden && privilege_add && (
                      <Button
                        variant="danger"
                        onClick={this.handleDelete}
                        style={{ width: "150px", marginRight: 0 }}
                      >
                        Clear Form
                      </Button>
                    )}
                  </div>
                </>
              )
            ) : (
              selectedStudent && (
                <>
                  <Table>
                    {selectedTitle?.items?.map((q) => {
                      const matchingFilledItem =
                        filledData.length > 0
                          ? filledData[0].items.find(
                              (filledItem) => filledItem.item_id === q.item_id
                            )
                          : null;

                      const preselectedValue = matchingFilledItem
                        ? matchingFilledItem.choices.find((filledChoice) =>
                            q.choices.some(
                              (choice) =>
                                choice.choice_id === filledChoice.choice_id
                            )
                          )?.choice || ""
                        : responses[q.item_id]?.value || "";

                      return (
                        <TableRow key={q.item_id}>
                          <TableCell>
                            <Typography variant="subtitle1" gutterBottom>
                              {q.item_name}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <RadioGroup
                              row
                              value={preselectedValue}
                              onChange={(event) => {
                                const selectedChoice = q.choices.find(
                                  (option) =>
                                    option.choice === event.target.value
                                );
                                this.handleResponseChange(
                                  q.item_id,
                                  selectedChoice?.choice_id,
                                  event.target.value
                                );
                              }}
                              disabled={!editVisibility}
                            >
                              {q.choices?.map((option, index) => (
                                <FormControlLabel
                                  key={index}
                                  value={option.choice}
                                  control={<Radio />}
                                  label={option.choice}
                                />
                              ))}
                            </RadioGroup>
                          </TableCell>

                          <TableCell>
                            {editVisibility && (
                              <div>
                                <IconButton
                                  onClick={() => this.clearResponse(q.item_id)}
                                  size="small"
                                >
                                  <RestartAltIcon />
                                </IconButton>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Table>

                  <TextField
                    label="Overall Comments"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={
                      filledData.length > 0
                        ? filledData[0]?.comment || ""
                        : overallComments
                    }
                    disabled={!editVisibility}
                    onChange={this.handleCommentsChange}
                  />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      {selectedTitle && privilege_edit && (
                        <Button
                          className="insert-btn"
                          variant="primary"
                          onClick={this.handleSubmit}
                          style={{ width: "150px", marginLeft: 0 }}
                        >
                          Save
                        </Button>
                      )}
                    </div>

                    {selectedTitle && privilege_edit && (
                      <Button
                        variant="danger"
                        onClick={this.handleDelete}
                        style={{ width: "150px", marginRight: 0 }}
                      >
                        Clear Form
                      </Button>
                    )}
                  </div>
                </>
              )
            )}
          </CardContent>
        </Card>
      </Container>
    );
  }
}

export default ManageFormView;
